function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DayFlag, SelectionState } from "./UI.js";
import { dateMatchModifiers } from "./utils/dateMatchModifiers.js";
/**
 * Return a function to get the modifiers for a given day.
 *
 * @private
 */
export function useGetModifiers(days, props, dateLib) {
  var disabled = props.disabled,
    hidden = props.hidden,
    modifiers = props.modifiers,
    showOutsideDays = props.showOutsideDays,
    today = props.today;
  var isSameDay = dateLib.isSameDay,
    isSameMonth = dateLib.isSameMonth,
    Date = dateLib.Date;
  var internal = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DayFlag.focused, []), DayFlag.outside, []), DayFlag.disabled, []), DayFlag.hidden, []), DayFlag.today, []);
  var custom = {};
  var selection = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SelectionState.range_end, []), SelectionState.range_middle, []), SelectionState.range_start, []), SelectionState.selected, []);
  var _iterator = _createForOfIteratorHelper(days),
    _step;
  try {
    var _loop = function _loop() {
      var day = _step.value;
      var date = day.date,
        displayMonth = day.displayMonth;
      var isOutside = Boolean(displayMonth && !isSameMonth(date, displayMonth));
      var isDisabled = Boolean(disabled && dateMatchModifiers(date, disabled, dateLib));
      var isHidden = Boolean(hidden && dateMatchModifiers(date, hidden, dateLib)) || !showOutsideDays && isOutside;
      var isToday = isSameDay(date, today !== null && today !== void 0 ? today : new Date());
      if (isOutside) internal.outside.push(day);
      if (isDisabled) internal.disabled.push(day);
      if (isHidden) internal.hidden.push(day);
      if (isToday) internal.today.push(day);
      // Add custom modifiers
      if (modifiers) {
        Object.keys(modifiers).forEach(function (name) {
          var modifierValue = modifiers === null || modifiers === void 0 ? void 0 : modifiers[name];
          var isMatch = modifierValue ? dateMatchModifiers(date, modifierValue, dateLib) : false;
          if (!isMatch) return;
          if (custom[name]) {
            custom[name].push(day);
          } else {
            custom[name] = [day];
          }
        });
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return function (day) {
    // Initialize all the modifiers to false
    var dayFlags = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DayFlag.focused, false), DayFlag.disabled, false), DayFlag.hidden, false), DayFlag.outside, false), DayFlag.today, false);
    var selectionStates = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SelectionState.range_end, false), SelectionState.range_middle, false), SelectionState.range_start, false), SelectionState.selected, false);
    var customModifiers = {};
    // Find the modifiers for the given day
    for (var name in internal) {
      var _days = internal[name];
      dayFlags[name] = _days.some(function (d) {
        return d === day;
      });
    }
    for (var _name in selection) {
      var _days2 = selection[_name];
      selectionStates[_name] = _days2.some(function (d) {
        return d === day;
      });
    }
    for (var _name2 in custom) {
      customModifiers[_name2] = custom[_name2].some(function (d) {
        return d === day;
      });
    }
    return _objectSpread(_objectSpread(_objectSpread({}, selectionStates), dayFlags), customModifiers);
  };
}